import React from "react";
import CSSModules from "react-css-modules";
import { injectIntl } from "react-intl";
import styles from "./get-app.style.scss";
import { isAndroidDevice, isIPhone } from "../../utils/mobileHelper";
import { ANDROID_STORE_URL, IOS_STORE_URL } from "../../constants/sunbit";
import LoadingBlocking from "../../components/loading/LoadingBlocking";

@injectIntl
@CSSModules({ ...styles })
class GetApp extends React.Component {
  componentDidMount() {
    if (isAndroidDevice()) {
      window.location = ANDROID_STORE_URL;
    } else if (isIPhone()) {
      window.location = IOS_STORE_URL;
    }
  }

  render() {
    return <LoadingBlocking />;
  }
}

export default GetApp;



// WEBPACK FOOTER //
// ./src/auth/get-app/get-app.container.js